import React from 'react'
import { Button, Col, Form, FormFeedback, FormGroup, Input, Label, ModalBody, ModalFooter, Row } from 'reactstrap';
import { ModalButtonCancel } from '../../constant';

export const FormMicEstatus = (props) => {

    const {
        closeDialog, loading, handleInputChange, methodAction, status, button,
    } = props;

    return (
        <Form className="" role="form" onSubmit={methodAction}>
            <Row>
                <Col md="12">
                    <FormGroup>
                        <Label className="label-admision">Nombre del estatus <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                        <Input
                            type="text"
                            name="status"
                            value={status}
                            autoComplete="off"
                            onChange={handleInputChange}
                            className='input-admision'

                        />
                        <FormFeedback>Debe contener 3 ó más caracteres</FormFeedback>
                    </FormGroup>
                </Col>
            </Row>
         
            <ModalFooter>
                <Button size="sm" color="primary" type="submit" className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}>
                    {button}
                </Button>
                <Button size="sm" color='danger' type="button" onClick={closeDialog}>{ModalButtonCancel}</Button>
            </ModalFooter>
        </Form>
    )
}
